export enum LineType {
    Undefined = 0,
    Inline = 1,
    Xline = 2,
    Line2D = 3,
    ZSlice = 4,
    Test = 5,
}